import { useQuery } from "@tanstack/react-query";

import { get } from "common/helpers/HTTP";

import { getDeploymentDomain } from "../utils";

async function getDeploymentAliasesRequest(): Promise<string[]> {
  return (
    await get(`agency/domains/${getDeploymentDomain()}/deployment/aliases`)
  ).record.aliases.map(({ alias }: { alias: string }) => alias);
}

export default function useDeploymentAliases() {
  const { data: deploymentAliases, isLoading: isLoadingDeploymentAliases } =
    useQuery({
      queryKey: ["deploymentAliases"],
      queryFn: () => getDeploymentAliasesRequest(),
      enabled: import.meta.env.MODE !== "production",
    });

  return {
    deploymentAliases,
    isLoadingDeploymentAliases,
  };
}
